import { useContext, useState } from "react";
import UserModal from "../Modal/UserModal";
import UserInformationCard from "./UserInformationCard";
import { useUpdateMissionDataMutation } from "modules/pvs_activities/redux/service/missions";
import { displayNotification } from "helpers";
import { MissionContext } from "../contexts/MissionTasksContext";

const MissionContactPerson = ({ canChangeMissionContactPerson }) => {
    const missionContext = useContext(MissionContext);
    const [showModal, setShowModal] = useState(false);
    const initModal = () => setShowModal(!showModal);
    const [updateMissionData, { isLoading: isUpdating }] = useUpdateMissionDataMutation();
    const handleSave = (data) => {
        try {
            updateMissionData({ missionId: missionContext.missionData.id, data: { "mission_contact_person_id": data.id } }).then((response) => {
                if (response.error) {
                    displayNotification("error", response.error);
                    missionContext.taskTrigger();
                } else {
                    displayNotification("success", "Successfully updated Saved");
                }
            });
        } catch (e) {
            console.log(e);
            displayNotification("error", "Failed to change mission delegate");
        }
    }
    return (
        <>
            <UserInformationCard
                cardHeaderText="Mission Contact Person"
                cardColor={"bg-light"}
                name={missionContext.missionData?.relationContactPerson?.name}
                email={missionContext.missionData?.relationContactPerson?.email}
                role={"Contact Person"}
                status={"Registered"}
                buttonText={missionContext.missionData?.relationContactPerson === null ? "Assign" : "Change"}
                showButton={missionContext.is_archived?false: canChangeMissionContactPerson()}
                change={initModal}
                infoText="Mission contact person is not registered."
            />
            <UserModal
                title={"Assign Contact person"}
                isShow={showModal}
                initModal={initModal}
                roleId={44}
                reloadData={handleSave}
                defaultValue={missionContext.missionData?.relationContactPerson?.id}
            />
        </>
    );
}
export default MissionContactPerson;